export default class SearchResultsLoadMoreJRBD {
	constructor(searchResultsListSelector, loadMoreButtonSelector) {
		this.settings = {
			$searchResultsList: $(searchResultsListSelector),
			$loadMoreBtn: $(loadMoreButtonSelector)
		};

		this.bindUIActions();
	}

	bindUIActions = () => {
		const { $searchResultsList, $loadMoreBtn } = this.settings;

		if ($searchResultsList != null) {
			const searchResultsList = $searchResultsList;
			const postsToShow = $('#js-results-to-show').val();
			const loadMoreBtn = $loadMoreBtn;
			const allResults = $('#js-all-results').val();

			// Function to hide posts exceeding the specified number
			const postTypeList = () => {
				searchResultsList.find('.js-search-result-single').each((index, element) => {
					if (index >= postsToShow) {
						$(element).addClass('hidden');
					}
				});
			};

			postTypeList(); // Initially hide exceeding posts

			let shownByDefault = $('.js-search-result-single:not(.hidden)').length;
			$('.js-shown-articles').text(shownByDefault);

			// Hide load more button if all posts are shown by default
			if (shownByDefault < postsToShow) {
				loadMoreBtn.removeClass('btn').addClass('hidden');
			}

			// Event listener for load more button click
			loadMoreBtn.on('click', () => {
				let morePosts = searchResultsList.find('.hidden');
				let counter = 0;

				morePosts.each(function() {
					if (counter >= postsToShow) {
						return false;
					}
					counter++;
					$(this).removeClass('hidden');
				});

				let postsShown = allResults - $('.js-search-result-single.hidden').length;
				$('.js-shown-articles').text(postsShown);

				// Hide load more button if no more posts to show
				if (searchResultsList.find('.hidden').length === 0) {
					loadMoreBtn.removeClass('btn').addClass('hidden');
				}
			});

			// Event listener for filter button click
			$('button[data-filter-results]').click((e) => {
				let $this = $(e.currentTarget);
				$this.siblings().removeClass('active');
				$this.addClass('active');

				let dataFilterResults = $this.attr('data-filter-results');

				// Show/hide posts based on filter button clicked
				if (dataFilterResults !== 'js-all-results') {
					$('.js-results').addClass('hidden');
					let elementToShow = $('.' + dataFilterResults);

					if (elementToShow.length > 0) {
						elementToShow.removeClass('hidden');

						// Count the filtered posts
						let allPosts = elementToShow.find('.js-search-result-single').length;

						// Update the shown posts text
						let postsShown = allPosts - elementToShow.find('.js-search-result-single.hidden').length;
						$('.js-shown-articles').text(postsShown);
					}
				} else {
					// Show all posts
					$('.js-results').removeClass('hidden');
				}
			});
		}
	};
}

// Initialize the class for different search result lists
new SearchResultsLoadMoreJRBD(".js-search-results-list-jrbd.products-list", ".js-search-result-load-more-jrbd.products-list");
new SearchResultsLoadMoreJRBD(".js-search-results-list-jrbd.articles-list", ".js-search-result-load-more-jrbd.articles-list");